<template>
  <div class="retail-order-tabs">
    <div class="retail-order-tab-list">
      <div
        v-for="order in orders"
        :key="order.id"
        class="retail-order-tab"
        :class="{ active: order.id === activeOrderId }"
        role="button"
        tabindex="0"
        @click="$emit('change', order.id)"
        @keydown.enter="$emit('change', order.id)"
        @keydown.space.prevent="$emit('change', order.id)"
      >
        <i
          :class="
            order.id === activeOrderId
              ? 'fas fa-shopping-cart'
              : 'fas fa-clipboard-list'
          "
        ></i>

        <span class="tab-label">
          <strong>{{ orderLabel(order) }}</strong>
          <span v-if="itemCount(order) > 0" class="order-count-badge">
            {{ formattedItemCount(order) }}
          </span>
        </span>

        <button
          v-if="orders.length"
          type="button"
          class="close-icon"
          :title="
            order.id === activeOrderId
              ? $t('retailSale.orderTabs.closeSession')
              : $t('retailSale.orderTabs.closeTab')
          "
          @click.stop="$emit('remove', order.id)"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <button type="button" class="add-tab" @click="$emit('add')">
        <i class="fas fa-plus"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { getOrderItemCount } from '../../utils/retail-sale'

export default {
  name: 'RetailSaleOrderTabs',
  props: {
    orders: {
      type: Array,
      default: () => []
    },
    activeOrderId: {
      type: Number,
      default: null
    }
  },
  methods: {
    orderLabel(order) {
      return this.$t('retailSale.orderTabs.orderLabel', {
        tab: order.id,
        order: String(order.id).padStart(3, '0')
      })
    },
    itemCount(order) {
      return getOrderItemCount(order)
    },
    formattedItemCount(order) {
      return this.itemCount(order).toFixed(2)
    }
  }
}
</script>

<style scoped src="../../styles/order-tabs.css"></style>
